var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4922 46.8754C23.9463 46.8855 24.6052 47.0312 25.0609 47.0742C25.6666 47.1314 26.2095 47.2162 26.7331 47.2736C27.9069 47.4021 28.9186 47.5054 30.085 47.6647L49.9998 50.0004V26.3545H23.4922V46.8754Z",
    fill: "#0092DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4922 3.02083V23.4376H49.9998V0C48.4773 0 45.0839 0.577816 43.344 0.726289L36.7396 1.50405C34.5165 1.81407 32.3083 2.03019 30.1363 2.28284L23.4922 3.02083Z",
    fill: "#0092DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 43.8545C0 44.2975 1.66479 44.3172 2.38138 44.3849L20.5823 46.5628V26.3545H0V43.8545Z",
    fill: "#0092DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.1458V23.4375H20.5823V3.4375C19.7962 3.4375 18.6572 3.62353 17.9519 3.71827C17.062 3.83778 16.1446 3.93321 15.3547 4.03227L1.02985 5.71945C0.605221 5.76394 0 5.72993 0 6.1458Z",
    fill: "#0092DD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/windows.f0114163c8e343f9a50c51742551b36d.svg";
export { ForwardRef as ReactComponent };